import ObjectCache from './CacheService';
import UserAccount from '../UserAccount';
import DatabaseApi from '../server/DatabaseApi';
import Database from '../../models/database';
import Company from '../Company';

class DatabaseCache extends ObjectCache {
  api = DatabaseApi;
  createNew = (title, description, name, connectionUrl) => new Database(null, UserAccount.account._id, [], [], UserAccount.account._id, title, description, name, connectionUrl, null, null, null, null, null, Company.company && Company.company._id || '');
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new Database(results._id, results.owner, results.users, results.teams, UserAccount.account._id, results.title, results.description, results.name, results.connectionUrl, results.createdTime, results.updateTime, results.state, results.shareSetting, results.version, results.company, results.background);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}

const singleton = new DatabaseCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
